export const getImageSrc = (value) => {
  const image = String(value || "").trim();
  if (!image) return "/default-product.jpg";
  if (image.startsWith("http://") || image.startsWith("https://") || image.startsWith("/")) return image;
  return `/${image}`;
};

export const compressProductImage = (file, maxWidth = 1400, quality = 0.82) =>
  new Promise((resolve, reject) => {
    if (!file?.type?.startsWith("image/")) return reject(new Error("لطفاً یک فایل تصویر انتخاب کنید"));
    const image = new Image();
    const objectUrl = URL.createObjectURL(file);
    image.onload = () => {
      const scale = Math.min(1, maxWidth / image.width);
      const canvas = document.createElement("canvas");
      canvas.width = Math.max(1, Math.round(image.width * scale));
      canvas.height = Math.max(1, Math.round(image.height * scale));
      canvas.getContext("2d").drawImage(image, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((blob) => {
        URL.revokeObjectURL(objectUrl);
        if (!blob) return reject(new Error("فشرده‌سازی تصویر انجام نشد"));
        resolve(new File([blob], `${file.name.replace(/\.[^.]+$/, "")}.webp`, { type: "image/webp" }));
      }, "image/webp", quality);
    };
    image.onerror = () => { URL.revokeObjectURL(objectUrl); reject(new Error("تصویر قابل خواندن نیست")); };
    image.src = objectUrl;
  });
